// src/index.tsx
import {
  useMultiStyleConfig,
  Flex,
  Text,
  Button,
  Link,
  useDisclosure,
  CloseButton
} from "@chakra-ui/react";
import { Info } from "@airhelp/icons";
import { jsx, jsxs } from "react/jsx-runtime";
var Banner = ({
  title,
  subtitle,
  buttonLabel,
  buttonAction,
  linkLabel,
  linkAction,
  variant,
  ...props
}) => {
  const styles = useMultiStyleConfig("Banner", { variant });
  const isContent = title || subtitle || linkLabel;
  const { isOpen, onClose } = useDisclosure({ defaultIsOpen: true });
  if (isOpen) {
    return /* @__PURE__ */ jsxs(Flex, {
      display: "flex",
      alignItems: "center",
      flexDirection: { base: "column", md: "row" },
      position: "sticky",
      justifyContent: "space-between",
      px: { base: 4, md: 6 },
      py: 3,
      "data-testid": "banner-wrap",
      __css: styles.container,
      ...props,
      children: [
        /* @__PURE__ */ jsxs(Flex, {
          width: "100%",
          alignItems: { base: "flex-start", md: "center" },
          py: 2,
          flexDirection: { base: "column", md: "row" },
          paddingRight: { base: isContent && 6, md: 0 },
          children: [
            /* @__PURE__ */ jsx(Info, {
              boxSize: 6,
              mr: 3,
              display: { base: "none", md: "initial" },
              sx: styles.icon
            }),
            title && /* @__PURE__ */ jsx(Text, {
              fontSize: "md",
              fontWeight: "medium",
              mr: { base: 0, md: 1 },
              mb: { base: 1, md: 0 },
              "data-testid": "banner-title",
              sx: styles.title,
              children: title
            }),
            subtitle && /* @__PURE__ */ jsx(Text, {
              fontSize: "md",
              mr: { base: 0, md: 1 },
              mb: { base: 1, md: 0 },
              "data-testid": "banner-subtitle",
              sx: styles.subtitle,
              children: subtitle
            }),
            linkLabel && /* @__PURE__ */ jsx(Link, {
              fontSize: "md",
              fontWeight: "normal",
              mr: { base: 0, md: 1 },
              mb: { base: 1, md: 0 },
              onClick: linkAction,
              "data-testid": "banner-link",
              sx: styles.link,
              children: linkLabel
            })
          ]
        }),
        /* @__PURE__ */ jsxs(Flex, {
          width: { base: "100%", md: "initial" },
          justifyContent: "flex-end",
          alignItems: "center",
          ml: { base: 0, md: 1 },
          children: [
            buttonLabel && /* @__PURE__ */ jsx(Button, {
              size: "xs",
              width: { base: "100%", md: "initial" },
              minWidth: "120px",
              mt: { base: 4, md: 0 },
              variant: "secondary",
              onClick: buttonAction,
              "data-testid": "banner-button",
              children: buttonLabel
            }),
            /* @__PURE__ */ jsx(CloseButton, {
              size: "sm",
              ml: { base: 0, md: 3 },
              onClick: onClose,
              position: { base: "absolute", md: "relative" },
              top: { base: 4, md: 0 },
              right: { base: 4, md: 0 },
              "data-testid": "banner-close",
              __css: styles.closeButton
            })
          ]
        })
      ]
    });
  }
  return null;
};
export {
  Banner
};
